import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

/**
 * @group Basic Toolkit
 * @component Smart Truncate Popover
 *
 * @export
 * @class LsqSmartTruncateComponent
 */

@Component({
    selector: 'lsq-smart-truncate',
    template: `
        <div
            #checkElement
            class="text-truncate"
            [popover]="popoverValue ? popoverValue : value"
            [popoverDisabled]="
                popoverValue === value && checkElement.offsetWidth >= checkElement.scrollWidth
            "
        >
            {{ value }}
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LsqSmartTruncateComponent {
    @Input() public value: string;
    @Input() public popoverValue?: string;

    constructor(public changeDetectorRefs: ChangeDetectorRef) {}

    ngAfterViewInit(): void {
        // Force a new change detection check after initial render to avoid ExpressionChangedAfterItHasBeenCheckedError error.
        setTimeout(() => {
            this.changeDetectorRefs.markForCheck();
        }, 0);
    }
}
